import React from "react";
import { Text, View, Image, StyleSheet } from "@react-pdf/renderer";

export const BRAND = {
  primary: "#1e3a8a",
  primaryDark: "#152a63",
  accent: "#2563eb",
  gold: "#f2b90c",
  slate: "#334155",
  slateLight: "#64748b",
  border: "#e2e8f0",
  zebra: "#f8fafc",
  logo: "/images/logo-Plastiforte-v2.png",
};

export const formatGeneratedAt = () =>
  new Date().toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const s = StyleSheet.create({
  headerBand: {
    backgroundColor: BRAND.primary,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  logoBox: {
    backgroundColor: "#ffffff",
    borderRadius: 3,
    paddingVertical: 3,
    paddingHorizontal: 8,
  },
  logo: { width: 105, height: 30, objectFit: "contain" },
  titleBlock: { alignItems: "flex-end" },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#ffffff",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  subtitle: { fontSize: 8, color: "#dbeafe", marginTop: 2 },
  accentBar: { height: 3, backgroundColor: BRAND.gold },
  metaBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#f1f5f9",
    borderBottomWidth: 1,
    borderBottomColor: BRAND.border,
    paddingVertical: 4,
    paddingHorizontal: 16,
    marginBottom: 10,
  },
  metaText: { fontSize: 7, color: BRAND.slateLight },
  metaTextBold: { fontSize: 7, color: BRAND.primary, fontWeight: "bold" },
  footer: {
    position: "absolute",
    bottom: 14,
    left: 20,
    right: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderTopWidth: 1,
    borderTopColor: BRAND.border,
    paddingTop: 6,
  },
  footerBrand: { fontSize: 7, color: BRAND.primary, fontWeight: "bold" },
  footerText: { fontSize: 7, color: "#94a3b8" },
});

export const ReportPdfHeader = ({
  title,
  subtitle = "Plastiforte S.R.L.",
  totalRecords,
  generatedAt,
}) => (
  <View fixed>
    <View style={s.headerBand}>
      <View style={s.logoBox}>
        <Image src={BRAND.logo} style={s.logo} />
      </View>
      <View style={s.titleBlock}>
        <Text style={s.title}>{title}</Text>
        <Text style={s.subtitle}>{subtitle}</Text>
      </View>
    </View>
    <View style={s.accentBar} />
    <View style={s.metaBar}>
      <Text style={s.metaText}>
        Generado el: <Text style={s.metaTextBold}>{generatedAt}</Text>
      </Text>
      {typeof totalRecords === "number" && (
        <Text style={s.metaText}>
          Total de registros: <Text style={s.metaTextBold}>{totalRecords}</Text>
        </Text>
      )}
    </View>
  </View>
);

export const ReportPdfFooter = () => (
  <View style={s.footer} fixed>
    <Text style={s.footerBrand}>Plastiforte S.R.L.</Text>
    <Text
      style={s.footerText}
      render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
    />
  </View>
);
